import React from 'react';
import { Flexbox, Heading, Text } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';

interface PipelineRunMessageOverlayProps {
  show: boolean;
  extendToNextTable?: boolean;
}

const OverlayContainer = styled.div<{ show: boolean; extendToNextTable?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: ${({ extendToNextTable }) => extendToNextTable ? 'calc(-100% - 10px)' : '0'};
  background-color: rgba(248, 248, 248, 0.75);
  display: ${({ show }) => (show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
  backdrop-filter: blur(1px);
`;

const MessageContainer = styled.div`
  text-align: center;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  max-width: 400px;
`;

const PipelineRunMessageOverlay: React.FC<PipelineRunMessageOverlayProps> = ({ show, extendToNextTable = false }) => {
  return (
    <OverlayContainer show={show} extendToNextTable={extendToNextTable} data-testid='pipeline-run-message-overlay'>
      <MessageContainer>
        <Flexbox justifyContent='center' alignItems='center' flexDirection='column' gap='16px'>
          <Heading level={3} bold>
            CPM daily refresh is currently active.
          </Heading>
          <Text>Please wait 30 minutes to access data.</Text>
        </Flexbox>
      </MessageContainer>
    </OverlayContainer>
  );
};

export default PipelineRunMessageOverlay;